import { Card, CardContent, Grid } from '@material-ui/core'
import defaultThumb from '../../../assets/img/default-program.png'

interface CombinedSummaryProps {
  notes: string
  qty: number
}

const CombinedSummary = ({ notes, qty }: CombinedSummaryProps) => {
  return (
    <Card className="summary-card">
      <div className="flex space-between header align-center">
        <strong>Program details</strong>
      </div>

      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={3} style={{ minHeight: 195 }}>
            <div className={'no-thumbnail'}>
              <div
                className={`thumbnail`}
                style={{
                  backgroundImage: `url(${defaultThumb})`,
                }}
              ></div>
            </div>
          </Grid>

          <Grid item xs={9}>
            <Grid container className="items">
              <Grid item xs={3}>
                Notes
              </Grid>
              <Grid item xs={9}>
                {notes}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default CombinedSummary
